import { useCookies } from 'react-cookie';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import { canCookieBeSecure } from '../../../../../helpers';

export function useVIPCodeCookie() {
  const [, setCookie, removeCookie] = useCookies();
  const { cookieSitePath } = useRootSelector(selectPageConfig);

  const setVIPCodeCookie = (vipCode: string) => {
    setCookie('vip_code', vipCode, {
      expires: new Date(Date.now() + 86400000), // 24 * 60 * 60 * 1000
      path: cookieSitePath,
      secure: canCookieBeSecure(),
    });
  };

  const removeVIPCodeCookie = () => {
    removeCookie('vip_code', {
      path: cookieSitePath,
      secure: canCookieBeSecure(),
    });
  };

  return { setVIPCodeCookie, removeVIPCodeCookie };
}
